"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceIntervalEnum = void 0;
var PriceIntervalEnum;
(function (PriceIntervalEnum) {
    PriceIntervalEnum[PriceIntervalEnum["ONE_TIME"] = 0] = "ONE_TIME";
    PriceIntervalEnum[PriceIntervalEnum["MONTHLY"] = 1] = "MONTHLY";
    PriceIntervalEnum[PriceIntervalEnum["QUARTERLY"] = 2] = "QUARTERLY";
    PriceIntervalEnum[PriceIntervalEnum["YEARLY"] = 3] = "YEARLY";
})(PriceIntervalEnum || (exports.PriceIntervalEnum = PriceIntervalEnum = {}));
